import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import request from '@/utils/request';
import { officialList } from '@/api';
export default {
  data: function data() {
    return {
      list: [],
      otherParameter: {},
      loaded: false
    };
  },
  methods: {
    queryOfficialList: function queryOfficialList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loaded = true;
              params = {
                pageNum: 1,
                pageSize: 2,
                catCodes: 'meet_professor'
              };
              _context.next = 4;
              return request.get(officialList, {
                params: params
              });
            case 4:
              res = _context.sent;
              _this.loaded = false;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              _this.list = res.obj.rows || [];
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    this.queryOfficialList();
  }
};